
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import { Component, Prop, Watch } from "vue-property-decorator";
import axios from "@/libraries/axios/main";
import BaseInternalChartValorization from "@/components/pages/valorizations/internal/observatory/BaseInternalChartValorization.vue";

@Component
export default class StatusOfThreatChart extends BaseInternalChartValorization {
  @Prop({
    type: String,
    default: () => null
  })
  // @ts-ignore
  stationProp: String | null;

  @Prop({
    type: String,
    default: () => null
  })
  // @ts-ignore
  groupProp: String | null ;

  @Prop({
    type: String,
    default: () => null
  })
  // @ts-ignore
  startDateProp: String | null;

  @Prop({
    type: String,
    default: () => null
  })
  // @ts-ignore
  endDateProp: String | null;

  protected url = "/valorization/observatory/fauna/status-of-threat";
  protected groups = {
    amphibian: {
      label: "Amphibiens",
      name: "amphibian"
    },

    chiropteres: {
      label: "Chauves-souris",
      name: "chiropteres"
    },

    coleopteres: {
      label: "Coléoptères",
      name: "coleopteres"
    },

    lepidopteres: {
      label: "Lépidoptères",
      name: "lepidopteres"
    },

    mammiferes_hors_chiro: {
      label: "Mammifères terrestres",
      name: "mammiferes_hors_chiro"
    },

    reptiles: {
      label: "Reptiles",
      name: "reptiles"
    },

    odonates: {
      label: "Odonates",
      name: "odonates"
    },

    orthopteres: {
      label: "Odonates",
      name: "orthopteres"
    },

    avifaune: {
      label: "Oiseaux",
      name: "avifaune"
    },

    all: {
      label: "Tous groupes faunistiques",
      name: "all"
    }
  };
  protected title = "Statuts de menace";
  protected subTitle = "Observatoire Faune";
  protected description = "";

  @Watch("stationProp")
  onStationPropChanged() {
    this.loadData();
  }

  @Watch("groupProp")
  onGroupPropChanged() {
    this.loadData();
  }

  loadData() {
    let vm = this;

    axios
      .post("/valorization/observatory/fauna/status-of-threat", {
        station: this.stationProp,
        group: this.groupProp,
        startDate: this.startDateProp,
        endDate: this.endDateProp
      })
      .then(response => {
        let data = response.data;

        this.properties = data.properties;
        this.error = data.error;
        this.message = data.message;
        this.model = data.model;
        this.data = data.data;

        let count = this.data.reduce((prev, cur) => prev + cur["count"], 0);

        this.data = count > 0 ? this.data : [];

        // Add and configure Series
        this.drawChart();

        this.series = this.chart.series.push(new am4charts.PieSeries());

        this.series.colors.list = [
          am4core.color("#c6c7c8"),
          am4core.color("#f29400"),
          am4core.color("#ffd542"),
          am4core.color("#99b034")
        ];

        am4core.options.autoSetClassName = true;

        this.series.dataFields.value = "count";
        SearchListPage.category = "status";

        // Let's cut a hole in our Pie chart the size of 30% the radius
        this.chart.innerRadius = am4core.percent(30);

        // Put a thick white border around each Slice
        this.series.slices.template.stroke = am4core.color("#fff");
        this.series.slices.template.strokeWidth = 2;
        this.series.slices.template.strokeOpacity = 1;
        // change the cursor on hover to make it apparent the object can be interacted with
        this.series.slices.template.cursorOverStyle = [
          {
            property: "cursor",
            value: "pointer"
          }
        ];

        this.series.labels.template.text = "{value.value} espèce";
        this.series.legendSettings.labelText = "{name}";
        // this.series.legendSettings.valueText = "";
        this.series.legendSettings.valueText = "{valueY.close}";
        // this.series.legendSettings.itemValueText = "[bold]{valueY}[/bold]";
        this.series.labels.template.adapter.add("text", function(text, target) {
          let response: string;
          switch (target.dataItem.value) {
            case 0:
              response = "";
              break;

            case 1:
              response = "1 espèce";
              break;

            default:
              response = text + "s";
              break;
          }

          return response;
        });

        // Create a base filter effect (as if it's not there) for the hover to return to
        let shadow = this.series.slices.template.filters.push(
          new am4core.DropShadowFilter()
        );
        shadow.opacity = 0;

        // Create hover state
        let hoverState = this.series.slices.template.states.getKey("hover"); // normally we have to create the hover state, in this case it already exists

        // Slightly shift the shadow and make it more prominent on hover
        let hoverShadow = hoverState.filters.push(
          new am4core.DropShadowFilter()
        );
        hoverShadow.opacity = 0.7;
        hoverShadow.blur = 5;

        // Add a legend
        this.chart.legend = new am4charts.Legend();
        this.chart.legend.name = "label";
        //
        // this.chart.legend.position = "bottom";
        // this.chart.legend.valign = "bottom";
        //
        // this.chart.legend.labels.template.textDecoration = "none";
        // this.chart.legend.valueLabels.template.textDecoration = "none";
        //
        // let as = this.chart.legend.labels.template.states.getKey("active");
        // as.properties.textDecoration = "line-through";
        // as.properties.fill = am4core.color("#000");
        //
        // let as2 = this.chart.legend.valueLabels.template.states.getKey("active");
        // as2.properties.textDecoration = "line-through";
        // as2.properties.fill = am4core.color("#000");
      })
      .catch(error => {
        let title = "Erreur";
        let description = "";

        // Error
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          console.log(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log("Error", error.message);

          // description = error.message;
        }
        console.log(error.config);
      })
      .finally(() => {
      });
  }

  mounted() {
    this.description = this.groups[this.groupProp].label;

    this.loadData();
  }
}
